import React, { useState, useEffect, useRef, useLayoutEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../../../assests/css/customer/Variables.css';
import { Search, Heart, ShoppingCart, Menu, Bell, User, Home, MoreHorizontal } from "lucide-react";
import { CgMoreO } from "react-icons/cg";
// import { Search, Heart, ShoppingCart, Menu, Bell, User, Home } from "lucide-react";
import { gsap } from "gsap";
import axios from "axios";
import Sidebar from "../Sidebar/Sidebar";
import AppContext from "../../../context/AppContext";
import SearchOverlay from "../searchbar/SearchDetail";
import NotificationDropdown from "./NotificationDropdown";
import "../../../assests/css/customer/Mynavbar.css";

const MyNavbar = () => {
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [hasActiveSale, setHasActiveSale] = useState(false);
  const {
    cartCount,
    setSelectedCategory,
    wishlistCount,
    isLoggedIn,
    baseUrl,
    notificationCount,
    setNotificationCount,
  } = useContext(AppContext);

  const location = useLocation();
  const activeTab = location.pathname;


  const menuRef = useRef(null);
  const indicatorRef = useRef(null);
  const notificationRef = useRef(null);


  const loadAllCategories = () => {
    axios
      .get(`${baseUrl}/customer/category/getAllCustomerCategories`)
      .then((res) => setCategories(res.data.categories || []))
      .catch((err) => console.error('Error fetching categories:', err));
  };
  //new function add kia h sale k leye///
  const checkActiveSale = () => {
    axios
      .get(`${baseUrl}/customer/products/getSaleProducts`)
      .then((res) => {
        console.log('SALE CHECK RESPONSE:', res.data);
        setHasActiveSale((res.data.products || []).length > 0);
      })
      .catch((err) => console.error('Sale check error:', err));
  };



  // ── Categories ────────────────────────────────────────────
  useEffect(() => {
    import("axios").then(({ default: axios }) => {
      axios
        .get(`${baseUrl}/customer/category/getAllCustomerCategories`)
        .then((res) => setCategories(res.data.categories || []))
        .catch((err) => console.error("Error fetching categories:", err));
      checkActiveSale();
    });




    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ── Active tab indicator (GSAP) ───────────────────────────
  useLayoutEffect(() => {
    if (!menuRef.current || !indicatorRef.current) return;
    const activeLink = menuRef.current.querySelector(".nav-link.active");
    if (!activeLink) {
      // Koi bhi nav-link active nahi (jaise /customer/profile) — indicator ko chhupao,
      // warna wo purani (last-active) position par stale reh jata hai
      gsap.to(indicatorRef.current, { width: 0, duration: 0.3, ease: "power3.out" });
      return;
    }
    const rect = activeLink.getBoundingClientRect();
    const menuRect = menuRef.current.getBoundingClientRect();
    gsap.to(indicatorRef.current, {
      x: rect.left - menuRect.left,
      width: rect.width,
      duration: 0.5,
      ease: "power3.out",
    });
  }, [activeTab]);

  // ── Handlers ─────────────────────────────────────────────
  const openSidebar = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);
   const toggleSidebar      = () => setSidebarOpen((prev) => !prev);
  const openSearch = () => setSearchOpen(true);
  const closeSearch = () => setSearchOpen(false);
  const toggleNotification = () => setNotificationOpen((prev) => !prev);
  const closeNotification = () => setNotificationOpen(false);

  const createRipple = (e, cat) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();
    const ripple = document.createElement("span");
    ripple.className = "ripple";
    ripple.style.left = `${e.clientX - rect.left}px`;
    ripple.style.top = `${e.clientY - rect.top}px`;
    el.appendChild(ripple);
    setTimeout(() => {
      ripple.remove();
      if (cat) {
        setSelectedCategory(cat);
        navigate(`/products/${cat.category_name}`);
      }
    }, 600);
  };

  return (
    <>
      <nav className={`main-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">

          <button className="mobile-menu-btn" onClick={openSidebar} aria-label="Open menu">
            <Menu />
          </button>

          <div className="logo">
            <Link to="/">MOONLIT</Link>
          </div>
          <ul className="nav-menu-desktop" ref={menuRef}>
            {categories.map((item) => (
              <CategoryLink
                key={item.id}
                item={item}
                activeTab={activeTab}
                onRipple={createRipple}
              />
            ))}
            {hasActiveSale && (
              <li>
                <Link
                  className={`nav-link ${activeTab === "/sale-products" ? "active" : ""}`}
                  to="/sale-products"
                >
                  Sale
                  <span className="desktop-glow" />
                </Link>
              </li>
            )}
            <div ref={indicatorRef} className="nav-indicator" />
          </ul>

          {/* <ul className="nav-menu-desktop" ref={menuRef}>
            {categories.map((item) => (
              <CategoryLink
                key={item.id}
                item={item}
                activeTab={activeTab}
                onRipple={createRipple}
              />
            ))}
            <div ref={indicatorRef} className="nav-indicator" />
          </ul> */}

          <div className="nav-right">
            <button className="nav-icon electric-icon" onClick={openSearch} aria-label="Search">
              <Search />
              <span className="icon-glow" />
            </button>

            <Link
              to="/wishlist"
              className={`nav-icon electric-icon ${activeTab === "/wishlist" ? "active" : ""}`}
              aria-label="Wishlist"
            >
              <Heart />
              <span className="icon-glow" />
              {wishlistCount > 0 && <span className="badge">{wishlistCount}</span>}
            </Link>

            <Link
              to="/cart"
              className={`nav-icon electric-icon ${activeTab === "/cart" ? "active" : ""}`}
              aria-label="Cart"
            >
              <ShoppingCart />
              <span className="icon-glow" />
              {cartCount > 0 && <span className="badge">{cartCount}</span>}
            </Link>

            <div ref={notificationRef} style={{ position: "relative" }}>
              <button
                className={`nav-icon electric-icon ${activeTab === "/notifications" || notificationOpen ? "active" : ""}`}
                onClick={toggleNotification}
                aria-label="Notifications"
              >
                <Bell />
                <span className="icon-glow" />
                {notificationCount > 0 && (
                  <span className="badge">{notificationCount}</span>
                )}
              </button>
              <NotificationDropdown
                isOpen={notificationOpen}
                onClose={closeNotification}
                onCountChange={setNotificationCount}
              />
            </div>

            {isLoggedIn ? (
              <Link
                to="/customer/profile"
                className={`nav-icon electric-icon ${activeTab === "/customer/profile" ? "active" : ""}`}
                aria-label="User Profile"
              >
                <User />
                <span className="icon-glow" />
              </Link>
            ) : (
              <Link to="/login" className="register-link" aria-label="Register">
                <span className="register-text">Login/Register</span>
                <span className="icon-glow" />
              </Link>
            )}
          </div>
        </div>
      </nav>

      <Sidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
        categories={categories}
        activeTab={activeTab}
        onCategoryClick={createRipple}
        hasActiveSale={hasActiveSale}
      />
      <SearchOverlay isOpen={searchOpen} onClose={closeSearch} />

    {/* Bottom mobile navbar */}
      <nav className="bottom-navbar">
        <Link
          to="/"
          className={`bottom-item ${activeTab === "/" ? "active" : ""}`}
        >
          <Home />
          <span className="mobile-glow" />
        </Link>

        <Link
          to="/wishlist"
          className={`bottom-item ${activeTab === "/wishlist" ? "active" : ""}`}
        >
          <Heart />
          <span className="mobile-glow" />
          {wishlistCount > 0 && <span className="badge">{wishlistCount}</span>}
        </Link>

        {isLoggedIn ? (
          <Link
            to="/customer/profile"
            className={`bottom-item ${activeTab === "/customer/profile" ? "active" : ""}`}
          >
            <User />
            <span className="mobile-glow" />
          </Link>
        ) : (
          <Link
            to="/login"
            className={`bottom-item ${activeTab === "/login" ? "active" : ""}`}
          >
            <User />
            <span className="mobile-glow" />
          </Link>
        )}

        <Link
          to="/cart"
          className={`bottom-item ${activeTab === "/cart" ? "active" : ""}`}
        >
          <ShoppingCart />
          <span className="mobile-glow" />
          {cartCount > 0 && <span className="badge">{cartCount}</span>}
        </Link>

        <button
          type="button"
          onClick={toggleSidebar}
          className={`bottom-item ${sidebarOpen ? "active" : ""}`}
          aria-label="More"
        >
          <CgMoreO />
          <span className="mobile-glow" />
        </button>
      </nav>
    </>
  );
};

// ── Category link ─────────────────────────────────────────────
const CategoryLink = ({ item, activeTab, onRipple }) => {
  const handleClick = (e) => {
    e.preventDefault(); // Link ka default navigation rok do — ripple ke baad createRipple khud navigate() karega
    onRipple(e, item);
  };
  return (
    <li>
      <Link
        to={`/products/${item.category_name}`}
        className={`nav-link ${activeTab === item.path ? "active" : ""}`}
        onClick={handleClick}
      >
        {item.category_name}
        <span className="desktop-glow" />
      </Link>
    </li>
  );
};

export default MyNavbar;